import React from "react";
import "./style.scss";
import SecondaryBanner from "../../components/sections/SecondaryBanner";
import GalleryBanner from "../../assets/images/about_gallery/galleryBanner.webp";
import gallery1 from "../../assets/images/about_gallery/g1.webp";
import gallery2 from "../../assets/images/about_gallery/g2.webp";
import gallery3 from "../../assets/images/about_gallery/g3.webp";
import gallery4 from "../../assets/images/about_gallery/g4.webp";
import gallery5 from "../../assets/images/about_gallery/g5.webp";
import gallery6 from "../../assets/images/about_gallery/g6.webp";
import gallery7 from "../../assets/images/about_gallery/g7.webp";
import gallery8 from "../../assets/images/about_gallery/g8.webp";
import gallery9 from "../../assets/images/about_gallery/g9.webp";
import gallery10 from "../../assets/images/about_gallery/g10.webp";
import gallery11 from "../../assets/images/about_gallery/g11.webp";
import gallery12 from "../../assets/images/about_gallery/g12.webp";
import gallery13 from "../../assets/images/about_gallery/g13.webp";
import gallery14 from "../../assets/images/about_gallery/g14.webp";
import gallery15 from "../../assets/images/about_gallery/g15.webp";
import gallery16 from "../../assets/images/about_gallery/g16.webp";
import gallery17 from "../../assets/images/about_gallery/g17.webp";
import gallery18 from "../../assets/images/about_gallery/g18.webp";
import gallery19 from "../../assets/images/about_gallery/g19.webp";
import gallery20 from "../../assets/images/about_gallery/g20.webp";
import gallery21 from "../../assets/images/about_gallery/g21.webp";
import gallery22 from "../../assets/images/about_gallery/g22.webp";
import gallery23 from "../../assets/images/about_gallery/g23.webp";
import gallery24 from "../../assets/images/about_gallery/g24.webp";
import gallery25 from "../../assets/images/about_gallery/g25.webp";
import gallery26 from "../../assets/images/about_gallery/g26.webp";
import gallery27 from "../../assets/images/about_gallery/g27.webp";
import gallery28 from "../../assets/images/about_gallery/g28.webp";
import gallery29 from "../../assets/images/about_gallery/g29.webp";
import gallery30 from "../../assets/images/about_gallery/g30.webp";
import gallery31 from "../../assets/images/about_gallery/g31.webp";
import gallery32 from "../../assets/images/about_gallery/g32.webp";
import gallery33 from "../../assets/images/about_gallery/g33.webp";
import gallery34 from "../../assets/images/about_gallery/g35.webp";
import gallery35 from "../../assets/images/about_gallery/g36.webp";
import gallery36 from "../../assets/images/about_gallery/g37.webp";
// import { useNavigate } from "react-router-dom";

const AboutGallery = () => {
  // const navigate = useNavigate();

  return (
    <>
      {/* Section:Banner */}
      <section>
        <SecondaryBanner
          imageUrl={GalleryBanner}
          title="About Us - Gallery"
          desc="Capturing the Spirit of Sitare"
        />
      </section>

      {/* Section: About Gallery Text */}
      <section className="global-aboutwrapper pb-0">
        <div className="container">
          <div className="row">

            <div className="col-12">
              <p className="global-bodytext">
                Explore the vibrant life at Sitare University Program through our gallery! From academic milestones to cultural celebrations, sports events, and inspiring moments, our gallery captures the essence of our dynamic campus and its incredible community.              </p>
            </div>
          </div>
        </div>
      </section>



      {/* Section: Gallery Filter */}
      <section className="global-aboutwrapper">
        {/* <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="al-filters">
                <div className="al-filters--wrapper">
                <p className="mb-0 bl-filters--text">Filter by</p>
                <select className="al-filters--select">
                  <option>This Year</option>
                  <option>Year 1</option>
                  <option>Year 2</option>
                </select>
                <select className="al-filters--select">
                  <option>Event Name</option>
                  <option>Topic 1</option>
                  <option>Topic 2</option>
                </select>
                </div>
              

                <button type="button" className="mb-0 al-filters--text">Reset Filters</button>
              </div>
            </div>
          </div>
        </div> */}

        {/* Section: Gallery Cards */}
        <div className="container mb-5">
          {/* <div className="row">
            <div className="col-12">
              <h1 className="global-heading global-fwbold my-5">
                Gallery
              </h1>
            </div>
          </div> */}

          <div className="row">
            <div className="col-12">
              <div className="al-gallery">
                <div className="al-gallery--image">
                  <img src={gallery1} alt="gallery-image" draggable="false" />
                </div>
                <div className="al-gallery--image">
                  <img src={gallery2} alt="gallery-image" draggable="false" />
                </div>
                <div className="al-gallery--image">
                  <img src={gallery3} alt="gallery-image" draggable="false" />
                </div>
                <div className="al-gallery--image">
                  <img src={gallery4} alt="gallery-image" draggable="false" />
                </div>
                <div className="al-gallery--image">
                  <img src={gallery5} alt="gallery-image" draggable="false" />
                </div>
                <div className="al-gallery--image">
                  <img src={gallery6} alt="gallery-image" draggable="false" />
                </div>
                <div className="al-gallery--image">
                  <img src={gallery7} alt="gallery-image" draggable="false" />
                </div>
                <div className="al-gallery--image">
                  <img src={gallery8} alt="gallery-image" draggable="false" />
                </div>
                <div className="al-gallery--image">
                  <img src={gallery9} alt="gallery-image" draggable="false" />
                </div>
                <div className="al-gallery--image">
                  <img src={gallery10} alt="gallery-image" draggable="false" />
                </div>
                <div className="al-gallery--image">
                  <img src={gallery11} alt="gallery-image" draggable="false" />
                </div>
                <div className="al-gallery--image">
                  <img src={gallery12} alt="gallery-image" draggable="false" />
                </div>
                <div className="al-gallery--image">
                  <img src={gallery13} alt="gallery-image" draggable="false" />
                </div>
                <div className="al-gallery--image">
                  <img src={gallery14} alt="gallery-image" draggable="false" />
                </div>
                <div className="al-gallery--image">
                  <img src={gallery15} alt="gallery-image" draggable="false" />
                </div>
                <div className="al-gallery--image">
                  <img src={gallery16} alt="gallery-image" draggable="false" />
                </div>
                <div className="al-gallery--image">
                  <img src={gallery17} alt="gallery-image" draggable="false" />
                </div>
                <div className="al-gallery--image">
                  <img src={gallery18} alt="gallery-image" draggable="false" />
                </div>
                <div className="al-gallery--image">
                  <img src={gallery19} alt="gallery-image" draggable="false" />
                </div>
                <div className="al-gallery--image">
                  <img src={gallery20} alt="gallery-image" draggable="false" />
                </div>
                <div className="al-gallery--image">
                  <img src={gallery21} alt="gallery-image" draggable="false" />
                </div>
                <div className="al-gallery--image">
                  <img src={gallery22} alt="gallery-image" draggable="false" />
                </div>
                <div className="al-gallery--image">
                  <img src={gallery23} alt="gallery-image" draggable="false" />
                </div>
                <div className="al-gallery--image">
                  <img src={gallery24} alt="gallery-image" draggable="false" />
                </div>
                <div className="al-gallery--image">
                  <img src={gallery25} alt="gallery-image" draggable="false" />
                </div>
                <div className="al-gallery--image">
                  <img src={gallery26} alt="gallery-image" draggable="false" />
                </div>
                <div className="al-gallery--image">
                  <img src={gallery27} alt="gallery-image" draggable="false" />
                </div>
                <div className="al-gallery--image">
                  <img src={gallery28} alt="gallery-image" draggable="false" />
                </div>
                <div className="al-gallery--image">
                  <img src={gallery29} alt="gallery-image" draggable="false" />
                </div>
                <div className="al-gallery--image">
                  <img src={gallery30} alt="gallery-image" draggable="false" />
                </div>
                <div className="al-gallery--image">
                  <img src={gallery31} alt="gallery-image" draggable="false" />
                </div>
                <div className="al-gallery--image">
                  <img src={gallery32} alt="gallery-image" draggable="false" />
                </div>
                <div className="al-gallery--image">
                  <img src={gallery33} alt="gallery-image" draggable="false" />
                </div>
                <div className="al-gallery--image">
                  <img src={gallery34} alt="gallery-image" draggable="false" />
                </div>
                <div className="al-gallery--image">
                  <img src={gallery35} alt="gallery-image" draggable="false" />
                </div>
                <div className="al-gallery--image">
                  <img src={gallery36} alt="gallery-image" draggable="false" />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Section: Gallery Cards */}
        {/* <div className="container mt-5">
          <div className="row">
            <div className="col-12">
              <h1 className="global-heading global-fwbold my-5">
                Coffee Club 2023
              </h1>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <div className="al-gallery">
                  <div className="al-gallery--image">
                      <img src={gallery1} alt="gallery-image" draggable="false" />
                  </div>
                  <div className="al-gallery--image">
                      <img src={gallery2} alt="gallery-image" draggable="false" />
                  </div>
                  <div className="al-gallery--image">
                      <img src={gallery3} alt="gallery-image" draggable="false" />
                  </div>
                  <div className="al-gallery--image">
                      <img src={gallery2} alt="gallery-image" draggable="false" />
                  </div>
                  <div className="al-gallery--image">
                      <img src={gallery3} alt="gallery-image" draggable="false" />
                  </div>
                  <div className="al-gallery--image">
                      <img src={gallery1} alt="gallery-image" draggable="false" />
                  </div>
              </div>
            </div>
          </div>
        </div> */}
      </section>
    </>
  );
};

export default AboutGallery;
